// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10xb1","select":"styles_select__cz_Ti"};